const isResolvedResource = require('../contentful/is-resolved-resource');
const makeTransformer = require('./make');
const modelTransformer = require('./model');
const variantTransformer = require('./variant');

const createEntryLink = (entry) => {
  return {
    sys: {
      type: 'Link',
      linkType: 'Entry',
      id: entry.id
    }
  };
};

module.exports = {
  contentfulToInternal(entry) {
    const result = {
      id: entry.sys.id,
      published: Boolean(entry.sys.publishedVersion),
      updated: entry.sys.publishedVersion && entry.sys.version > entry.sys.publishedVersion + 1,
      draft: !entry.sys.publishedVersion,
      archived: Boolean(entry.sys.archivedVersion),
      contentType: null,

      name: (entry.fields.name ? entry.fields.name['nb-NO'] : ''),
      term: (entry.fields.term ? entry.fields.term['nb-NO'] : null),
      range: (entry.fields.range ? entry.fields.range['nb-NO'] : null),
      advance: (entry.fields.advance ? entry.fields.advance['nb-NO'] : null),
      arrangementFee: (entry.fields.arrangementFee ? entry.fields.arrangementFee['nb-NO'] : null),
      price: (entry.fields.price ? entry.fields.price['nb-NO'] : null),
      interest: (entry.fields.interest ? entry.fields.interest['nb-NO'] : null),
      prices: (entry.fields.prices ? entry.fields.prices['nb-NO'] : null),
      advances: (entry.fields.advances ? entry.fields.advances['nb-NO'] : null),
      info: (entry.fields.info ? entry.fields.info['nb-NO'] : null),
      shipmentText: (entry.fields.shipmentText ? entry.fields.shipmentText['nb-NO'] : null),

      model: null,
      variant: null
    };

    if (entry.sys && entry.sys.contentType) {
      result.contentType = entry.sys.contentType.sys.id;
    }

    // Handle make link:
    if (entry.fields.make && entry.fields.make['nb-NO'] && isResolvedResource(entry.fields.make['nb-NO'])) {
      result.make = makeTransformer.contentfulToInternal(entry.fields.make['nb-NO']);
    }

    // Handle model link:
    if (entry.fields.model && entry.fields.model['nb-NO'] && isResolvedResource(entry.fields.model['nb-NO'])) {
      result.model = modelTransformer.contentfulToInternal(entry.fields.model['nb-NO']);
    }

    // Handle variant link:
    if (entry.fields.variant && entry.fields.variant['nb-NO'] && isResolvedResource(entry.fields.variant['nb-NO'])) {
      result.variant = variantTransformer.contentfulToInternal(entry.fields.variant['nb-NO']);
    }

    return result;
  },

  internalToContentful(lease) {
    const result = {
      fields: {
        name: {
          'nb-NO': lease.name
        },
        info: {
          'nb-NO': lease.info
        },
        shipmentText: {
          'nb-NO': lease.shipmentText
        },
        price: {
          'nb-NO': parseInt(lease.price, 10)
        },
        interest: {
          // 'nb-NO': parseFloat(parseFloat(lease.interest).toFixed(2)
          'nb-NO': Math.round(lease.interest * 100) / 100
        },
        term: {
          'nb-NO': parseInt(lease.term, 10)
        },
        range: {
          'nb-NO': parseInt(lease.range, 10)
        },
        advance: {
          'nb-NO': parseInt(lease.advance, 10)
        },
        arrangementFee: {
          'nb-NO': parseInt(lease.arrangementFee, 10)
        },
        variant: null,
        make: null,
        model: null
      },
      overwriteKeys: []
    };

    if (lease.make) {
      result.fields.make = {
        'nb-NO': createEntryLink(lease.make)
      };
    }

    if (lease.model) {
      result.fields.model = {
        'nb-NO': createEntryLink(lease.model)
      };
    }

    if (lease.variant) {
      result.fields.variant = {
        'nb-NO': createEntryLink(lease.variant)
      };
    }

    if (typeof lease.prices !== 'undefined') {
      result.fields.prices = {
        'nb-NO': lease.prices
      };

      result.overwriteKeys.push('prices');
    }

    if (typeof lease.advances !== 'undefined') {
      result.fields.advances = {
        'nb-NO': lease.advances
      };

      result.overwriteKeys.push('advances');
    }

    return result;
  }
};
